import { animateBackdrop } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export const NavItemGroup = ({ align, animated, children, className, layout, ...rest }) => {
    const listRef = useRef(null);
    useEffect(() => {
        if (listRef && listRef.current && animated) {
            animateBackdrop(listRef.current);
        }
    }, [children, animated]);
    return (React.createElement("ol", { className: cx(
        // The TDS classes for `tds-site-nav-items` will also be renamed in a future major
        'tds-site-nav-items', {
            [`tds-align--${align}`]: align,
            [`tds-site-nav-items--${layout}`]: layout,
        }, className), ref: listRef, ...rest },
        animated && React.createElement("div", { className: "tds-animate--backdrop-backdrop" }),
        React.Children.map(children, (child) => child && React.createElement("li", null, child))));
};
